import { get, writable } from 'svelte/store';

const STORAGE_KEY = 'shelly_dev_nav_dock_fade_height_v2';
/** Default fade band reaches well above the pill (dock floor → upward). */
export const NAV_DOCK_FADE_HEIGHT_DEFAULT = 35;
export const NAV_DOCK_FADE_HEIGHT_MIN = 0;
export const NAV_DOCK_FADE_HEIGHT_MAX = 280;

const clampFadeHeight = (value: number): number => {
	if (!Number.isFinite(value)) return NAV_DOCK_FADE_HEIGHT_DEFAULT;
	return Math.min(NAV_DOCK_FADE_HEIGHT_MAX, Math.max(NAV_DOCK_FADE_HEIGHT_MIN, Math.round(value)));
};

const readInitialValue = (): number => {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored === null) return NAV_DOCK_FADE_HEIGHT_DEFAULT;
		return clampFadeHeight(Number(stored));
	} catch {
		return NAV_DOCK_FADE_HEIGHT_DEFAULT;
	}
};

/**
 * Height (px) of the floating-dock scroll fade, measured upward from the dock
 * floor. Applied as `--floating-dock-fade-height` on `:root`. Preference is
 * saved locally.
 */
export const navDockFadeHeightPx = writable<number>(readInitialValue());

const applyFadeHeightCss = (px: number) => {
	if (typeof document === 'undefined') return;
	document.documentElement.style.setProperty('--floating-dock-fade-height', `${px}px`);
};

navDockFadeHeightPx.subscribe((value) => {
	const next = clampFadeHeight(value);
	try {
		localStorage.setItem(STORAGE_KEY, String(next));
	} catch {
		// localStorage may be unavailable
	}
	applyFadeHeightCss(next);
});

export const getNavDockFadeHeightPx = (): number => get(navDockFadeHeightPx);

export const setNavDockFadeHeightPx = (px: number) => {
	navDockFadeHeightPx.set(clampFadeHeight(px));
};
